import { DataArray, IDataArray, User } from './../../shared/index';

export class Device implements IDataArray {
    public Id: number;
    public UserId: number;
    public SkeletonKey: string;
    public LastSeen: Date;
    public DeviceId: string;
    public AndroidDeviceId: string;

    public IosDevice: IOSDevice = new IOSDevice();
    public User: User = new User();

    public GetById(): number {
        return this.Id;
    }
}

export class IOSDevice {
    public iOSDeviceId: string;
}
